import React, { useEffect, useState } from "react";
import { Link, useOutletContext } from "react-router-dom";
import { motion } from "framer-motion";
import axios from "axios";
import AddFeedback from "./components/AddFeedback";
import AddTeamFeedback from "./components/AddTeamFeedback";

function Myhr() {
  const { token } = useOutletContext();
  const [showAddFeedbackModal, setShowAddFeedbackModal] = useState(false);
  const [showAddTeamFeedbackModal, setShowAddTeamFeedbackModal] = useState(false);
  const [hasConfirmation, setHasConfirmation] = useState(false);
  const user = JSON.parse(localStorage.getItem("user") || "{}");
  const enb_user = user?.designation_id > 8 ? 1 : 0;
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    if (!user?.id) return;
    axios
      .get(`${API_BASE_URL}/employeeinfos/check_confirmation/${user.id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        setHasConfirmation(res.data?.conffeed === true);
      })
      .catch((error) => {
        console.error("Error checking confirmation:", error);
        setHasConfirmation(false);
      });
  }, [token]);


const fadeUp = (delay = 0) => ({
  initial: { opacity: 0, y: 16 },
  animate: { opacity: 1, y: 0 },
  transition: { delay, duration: 0.35, ease: [0.22, 1, 0.36, 1] },
});

const HR_CARDS = [
  {
    key: "user-attendance-view",
    label: "Attendance",
    title: "My Attendance",
    desc: "View your attendance history, check-in/check-out records, working hours, and attendance status.",
    icon: "fa-solid fa-clock",
    iconClass: "icon-teal",
    link: "/personalinfo/attendanceView",
  },
  {
    key: "leave",
    label: "Time Off",
    title: "Leave Management",
    desc: "Apply for leave, track approvals, and monitor your leave balance.",
    icon: "fa-solid fa-calendar-days",
    iconClass: "icon-amber",
    link: "/leaveinfos/view",
  },
  {
    key: "travel",
    label: "Business Travel",
    title: "Travel Management",
    desc: "Raise travel requests and track approvals seamlessly.",
    icon: "fa-solid fa-plane-departure",
    iconClass: "icon-teal",
    link: "/travelinfos/view",
  },
  {
    key: "self-assessment",
    label: "Performance",
    title: "Self-Assessment",
    desc: "Rate yourself and share your achievements for the current appraisal cycle.",
    icon: "fa-solid fa-clipboard-check",
    iconClass: "icon-blue",
    modalType: "self",
  },  
  {
    key: "team-assessment",
    label: "Team Review",
    title: "Team-Assessment",
    desc: "Rate your team members and share there achievements for the current appraisal cycle.",
    icon: "fa-solid fa-clipboard-check",
    iconClass: "icon-teal",
    modalType: "team",
  },
 
{
    key: "reimbursements",
    label: "Expenses",
    title: "Reimbursements",
    desc: "Submit reimbursement claims, track approval status, and view your reimbursement history.",
    icon: "fa-solid fa-receipt",
    iconClass: "icon-amber",
    link: "/reimbursements/view",
},
];

const QUICK_ACTIONS = [
  // { label: "Download payslip", icon: "fa-solid fa-download" },
  { label: "View policies", icon: "fa-solid fa-file-lines", link: "/personalinfo/policy" },
  { label: "Update profile", icon: "fa-solid fa-user-pen", link: "/personalinfo/myprofile" },
  { label: "My Team", icon: "fa-solid fa-user-group", link: "/personalinfo/myteam" },
  ...(hasConfirmation ? [{ label: "Feedback", icon: "fa-solid fa-clipboard-check", link: `/personalinfo/confirmationFeedback/${user?.id}` }] : []),
];

const styles = `
  .myhr-card { cursor: pointer; height: 100%; }
  .myhr-card .card {
    border: 0.5px solid #e5e7eb !important;
    border-radius: 12px !important;
    padding: 1.5rem;
    height: 100%;
    transition: border-color 0.2s;
    background: #fff;
  }
  .myhr-card:hover .card { border-color: #9ca3af !important; }
  .myhr-card .card-top {
    display: flex; align-items: flex-start;
    justify-content: space-between; margin-bottom: 1.25rem;
  }
  .myhr-card .icon-box {
    width: 40px; height: 40px; border-radius: 10px;
    display: flex; align-items: center; justify-content: center; font-size: 17px;
  }
  .myhr-card .icon-blue  { background: #E6F1FB; color: #185FA5; }
  .myhr-card .icon-amber { background: #FAEEDA; color: #854F0B; }
  .myhr-card .icon-teal  { background: #E1F5EE; color: #0F6E56; }
  .myhr-card .arrow-circle {
    width: 28px; height: 28px; border-radius: 50%;
    border: 0.5px solid #e5e7eb;
    display: flex; align-items: center; justify-content: center;
    color: #9ca3af; font-size: 11px;
    transition: background 0.15s, border-color 0.15s, color 0.15s;
  }
  .myhr-card:hover .arrow-circle { background: #f3f4f6; border-color: #d1d5db; color: #111; }
  .myhr-card .c-label {
    font-size: 11px; font-weight: 600; color: #9ca3af;
    text-transform: uppercase; letter-spacing: 0.06em; margin-bottom: 5px;
  }
  .myhr-card .c-title { font-size: 15px; font-weight: 500; color: #111827; margin-bottom: 6px; }
  .myhr-card .c-desc  { font-size: 13px; color: #6b7280; line-height: 1.6; }
  .qa-item {
    background: #f9fafb; border: 0.5px solid transparent;
    border-radius: 8px; padding: 14px 12px;
    display: flex; flex-direction: column; align-items: flex-start; gap: 10px;
    cursor: pointer; transition: background 0.15s, border-color 0.15s;
    height: 100%;
  }
  .qa-item:hover { background: #fff; border-color: #e5e7eb; }
  .qa-item .qa-icon { font-size: 18px; color: #6b7280; }
  .qa-item .qa-text { font-size: 12px; color: #6b7280; font-weight: 500; line-height: 1.4; }
`;

function HrCard({ card, index, onClick }) {
  const inner = (
    <motion.div className="myhr-card" {...fadeUp(index * 0.07)} whileHover={{ y: -2 }}>
      <div className="card border-0">
        <div className="card-top">
          <div className={`icon-box ${card.iconClass}`}>
            <i className={card.icon}></i>
          </div>
          <div className="arrow-circle">
            <i className="fa-solid fa-arrow-up-right"></i>
          </div>
        </div>
        <div className="c-label">{card.label}</div>
        <div className="c-title">{card.title}</div>
        <div className="c-desc">{card.desc}</div>
      </div>
    </motion.div>
  );

if (card.modalType) {
  return (
    <div className="col-xl-4 col-md-6 mb-3" onClick={onClick}>
      {inner}
    </div>
  );
}
  return (
    <div className="col-xl-4 col-md-6 mb-3">
      <Link to={card.link} className="text-decoration-none d-block h-100">
        {inner}
      </Link>
    </div>
  );
}


  return (
    <div className="content">
      <style>{styles}</style>

      {/* HEADER */}
      <motion.div
        className="d-flex align-items-start justify-content-between mb-4"
        {...fadeUp(0)}
      >
        <div>
          <h2 className="mb-1">My Hub</h2>
          <p className="fs-12 text-secondary mb-0">Your workspace for FY 2026–27</p>
        </div>
        <span
          className="fs-12 text-secondary mt-1"
          style={{ padding: "5px 14px", border: "0.5px solid #e5e7eb", borderRadius: 20, background: "#f9fafb", whiteSpace: "nowrap" }}
        >
          FY 2026–27
        </span>
      </motion.div>

      {/* MAIN CARDS */}
      <div className="row">
        {HR_CARDS.map((card, i) => {
          let handleClick;

          if (card.modalType === "self") {
            handleClick = () => setShowAddFeedbackModal(true);
          }

          if (card.modalType === "team") {
            handleClick = () => setShowAddTeamFeedbackModal(true);
          }

          return (
            <HrCard
              key={card.key}
              card={card}
              index={i}
              onClick={handleClick}
            />
          );
        })}
      </div>

      {/* DIVIDER */}
      <hr style={{ borderColor: "#e5e7eb", margin: "1.5rem 0 1.25rem", borderWidth: "0.5px" }} />

      {/* QUICK ACTIONS */}
      <motion.div {...fadeUp(0.28)}>
        <p className="mb-3" style={{ fontSize: 11, fontWeight: 600, color: "#9ca3af", textTransform: "uppercase", letterSpacing: "0.06em" }}>
          Quick actions
        </p>
        <div className="row row-cols-2 row-cols-md-4 g-2">
          {QUICK_ACTIONS.map((action, i) => (
            <div className="col" key={action.label}>
              <Link to={action.link} className="text-decoration-none d-block h-100">
                  <motion.div className="qa-item" whileHover={{ y: -1 }} whileTap={{ scale: 0.98 }} {...fadeUp(0.32 + i * 0.05)}>
                    <i className={`${action.icon} qa-icon`}></i>
                    <span className="qa-text">{action.label}</span>
                  </motion.div>
              </Link>
            </div>
          ))}
        </div>
      </motion.div>

        {/* DIVIDER */}
      <hr style={{ borderColor: "#e5e7eb", margin: "1.5rem 0 1.25rem", borderWidth: "0.5px" }} />

      {/* MODAL */}
      {showAddFeedbackModal && (
        <AddFeedback
          show={showAddFeedbackModal}
          onClose={() => setShowAddFeedbackModal(false)}
          user_id={user?.id}
          designation_id={user?.designation_id}
          year={"2025-2026"}
          token={token}
          onSuccess={async () => setShowAddFeedbackModal(false)}
        />
      )}

      {showAddTeamFeedbackModal && (
            <AddTeamFeedback
                show={showAddTeamFeedbackModal}
                onClose={() => {
                setShowAddTeamFeedbackModal(false);
                }}
                user_id={user?.id}
                year={"2025-2026"}
                token={token}
                onSuccess={async () => {
                setShowAddTeamFeedbackModal(false);
                }}
                enb_user={enb_user}
            />
            )}
    </div>
  );
}

export default Myhr;